<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="consts.meetingType.customer">
      <div class="row justify-content-center mh-100vh">
        <div class="text-center">
          <h4 class="pt-3">Best Wishes on Your Wedding.</h4>
          <p class="pt-3" style="white-space: break-spaces; font-size: larger">
            お打ち合わせいただきありがとうございました<br>
            おふたりのフラワーコーディネートが素敵になりますよう<br>
            精一杯ご準備させていただきます<br>
            当日までどうぞよろしくお願いいたします
          </p>
        </div>

        <div>
          <img class="w-100" :src="imageUrl" alt="meeting finish" />
        </div>
      </div>
    </CustomerMeetingLayout>
  </CommonLayout>
</template>

<script>
import CommonLayout from '@/layout/CommonLayout'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import mstore from '@/store/meeting-store'
import cstore from '@/store/customer-store'

export default {
  name: 'CustomerMeetingFinish',
  components: {
    CommonLayout,
    CustomerMeetingLayout
  },
  data () {
    return {
      imageUrl: '',
      customerDisplayFlag:
        cstore.getters.customerDisplayFlag === null
          ? false
          : cstore.getters.customerDisplayFlag
    }
  },
  computed: {
    // フローリストとの疎通確立フラグ取得
    getIsTargetAtendeeActive () {
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getSignalingData (newData) {
      if (!newData || newData.event !== 'click') return

      if (newData.id === 'prev' && newData.target_path) {
        this.$router.push(newData.target_path)
        return
      }

      if (newData.id === 'priceHide') {
        cstore.commit('setCustomerDisplayFlag', false)
        this.customerDisplayFlag = cstore.getters.customerDisplayFlag
      } else if (newData.id === 'priceDisplay') {
        cstore.commit('setCustomerDisplayFlag', true)
        this.customerDisplayFlag = cstore.getters.customerDisplayFlag
      }
    }
  },
  mounted () {
    sessionStorage.removeItem('lastRoutePath')
    sessionStorage.removeItem('customerIsOperationPossible')
    localStorage.removeItem('tabInfo')

    this.imageUrl = this.config.imageURL + '/meeting-contents/mtg-finish.jpg'
  }
}
</script>
